import { z } from "zod";
import { rawDealProductSchema } from "./deal-product.schema";

export const dealResponseSchema = z.object({
    getDeal: z.object({
        id: z.coerce.number(),
        products: z.array(rawDealProductSchema),
    }),
});
